// import {CircleBufferGeometry} from "three";

import {
    BufferGeometry, Float32BufferAttribute, Vector2, Vector3
} from 'three';

export class RoundedRect extends BufferGeometry {

    constructor(width = 3, height = 3, radius = 0.5, bendingRadius = 1, segments = 8, wSegments = 10) {

        super();

        this.type = 'RoundedRect';

        this.parameters = {
            radius,
            height,
            width,
            segments,
            wSegments,
            bendingRadius
        };

        segments = Math.max(2, segments);
        wSegments = Math.max(2, wSegments);
        const dw2 = 0.5 * Math.max(width - radius * 2, 0);
        const roundCY = (0.5 * height - radius);
        const bradius = bendingRadius;

        // buffers

        const indices = [];
        const vertices = [];
        const verticesXY = [];
        const normals = [];
        const uvs = [];

        // helper variables

        const vertex = new Vector3();
        const uv = new Vector2();

        let rad = 0;

        // Add indices of 4 triangles in the column
        const pushIndices = (i) => {
            if (i % 4 === 0) {
                indices.push(i, i + 1, i + 4);
            } else if (i % 4 === 3) {
                indices.push(i + 4, i + 3, i);
            } else {
                indices.push(i + 3, i, i + 4);
                indices.push(i + 1, i, i + 4);
            }
        };

        // LEFT

        for (let s = 0; s <= segments; s += 1) {

            const segment = (0.5 + 0.5 * (s / segments)) * Math.PI;

            // vertex

            vertex.x = -dw2 + radius * Math.cos(segment);
            vertex.y = roundCY + radius * Math.sin(segment);

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.x = 0.5 + (vertex.x / width);
            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            vertex.x = -dw2 - radius * (s / segments);
            rad = vertex.x / bradius;

            vertex.y = roundCY;

            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.x = 0.5 + (vertex.x / width);
            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            vertex.y = -roundCY;

            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.x = 0.5 + (vertex.x / width);
            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            vertex.x = -dw2 + radius * Math.cos(segment);
            vertex.y = -roundCY - radius * Math.sin(segment);

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.x = 0.5 + (vertex.x / width);
            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            // normal

            normals.push(0, 0, 1);
            normals.push(0, 0, 1);
            normals.push(0, 0, 1);
            normals.push(0, 0, 1);

        }

        // indices

        for (let i = 0; i <= segments * 4; i += 1) {

            pushIndices(i);

        }

        // RIGHT
        // center point

        for (let s = 0; s <= segments; s += 1) {

            const segment = 0.5 * ((segments - s) / segments) * Math.PI;

            // vertex + uv

            vertex.x = dw2 + radius * Math.cos(segment);
            vertex.y = roundCY + radius * Math.sin(segment);

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.x = 0.5 + (vertex.x / width);
            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            vertex.x = dw2 + radius * (s / segments);
            rad = vertex.x / bradius;

            vertex.y = roundCY;

            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.x = 0.5 + (vertex.x / width);
            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            vertex.y = -roundCY;

            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.x = 0.5 + (vertex.x / width);
            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            vertex.x = dw2 + radius * Math.cos(segment);
            vertex.y = -roundCY - radius * Math.sin(segment);

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.x = 0.5 + (vertex.x / width);
            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            // normal

            normals.push(0, 0, 1);
            normals.push(0, 0, 1);
            normals.push(0, 0, 1);
            normals.push(0, 0, 1);

        }

        // indices

        for (let i = (segments + 1) * 4; i <= 8 * segments + 4 - 1; i += 1) {

            pushIndices(i);

        }

        // CENTER
        for (let s = 0; s <= wSegments; s += 1) {

            // vertices + uv

            vertex.x = dw2 * (1 - (s * 2) / wSegments);
            rad = vertex.x / bradius;

            vertex.y = roundCY + radius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.x = 0.5 + (vertex.x / width);
            uv.y = 1;

            uvs.push(uv.x, uv.y);

            vertex.y = roundCY;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            vertex.y = -roundCY;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.y = 0.5 + (vertex.y / height);

            uvs.push(uv.x, uv.y);

            vertex.y = -roundCY - radius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            uv.y = 0;

            uvs.push(uv.x, uv.y);

            // normal

            normals.push(0, 0, 1);
            normals.push(0, 0, 1);
            normals.push(0, 0, 1);
            normals.push(0, 0, 1);

        }

        // indices
        for (let i = (segments + 1) * 8; i <= (vertices.length / 3) - 5; i += 1) {

            pushIndices(i);

        }

        // build geometry

        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('positionXY', new Float32BufferAttribute(verticesXY, 2));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    }

    /*
    changeHeight(value) {
        const {
            // radius,
            height,
            // width,
            segments,
            wSegments
            // bendingRadius
        } = this.parameters;
        const dh = (value - height) * 0.5;

        this.parameters.height = value;

        console.log(height, dh, value);

        const positionsBuffer = this.getAttribute('position');

        for (let s = 0; s <= segments * 2 + wSegments + 2; s += 1) {
            let y = positionsBuffer.getY(s * 4);

            positionsBuffer.setY(s * 4, y + dh);

            y = positionsBuffer.getY(s * 4 + 1);
            positionsBuffer.setY(s * 4 + 1, y + dh);

            y = positionsBuffer.getY(s * 4 + 2);
            positionsBuffer.setY(s * 4 + 2, y - dh);

            y = positionsBuffer.getY(s * 4 + 3);
            positionsBuffer.setY(s * 4 + 3, y - dh);
        }

        this.needsUpdate = true;
    }

     */

    static fromJSON(data) {

        return new RoundedRect(data.radius, data.segments, data.wSegments);

    }

}
